__turbopack_context__.v({
  "track": "villa-host-city-carousel-module-scss-module__WVoAea__track",
  "villa-host-city-marquee": "villa-host-city-carousel-module-scss-module__WVoAea__villa-host-city-marquee",
});
